// ---------------------------------------------------------------------------
// Coin reward values for game completion (Phase 1 economy nerf).
//
// Separated from economyCatalog.js so each game mode can have its own table.
// These are client-side display values; the server (game-round edge function)
// is authoritative and enforces the daily cap.
// ---------------------------------------------------------------------------

// ── Unlimited win coin rewards ──────────────────────────────────────────────
export const UNLIMITED_WIN_COINS = Object.freeze({
  byGuessesUsed: Object.freeze({
    1: 20,
    2: 14,
    3: 10,
    4: 7,
    5: 5,
  }),
  default: 4,
});

// ── Generations win coin rewards (slightly higher — each round costs 100) ───
export const GENERATIONS_WIN_COINS = Object.freeze({
  byGuessesUsed: Object.freeze({
    1: 25,
    2: 18,
    3: 12,
    4: 8,
    5: 6,
  }),
  default: 5,
});

// ── Loss reward (all modes) ─────────────────────────────────────────────────
export const LOSS_REWARD_COINS = 0;

// ── Daily coin-earn cap (server-enforced, mirrored here for UI display) ─────
export const DAILY_COIN_CAP = 120;

// ── Helpers ─────────────────────────────────────────────────────────────────

const REWARD_TABLES = {
  unlimited: UNLIMITED_WIN_COINS,
  generations: GENERATIONS_WIN_COINS,
};

/**
 * Get the win coin reward for a given game type and number of guesses.
 * Falls back to Unlimited table if the game type isn't recognized.
 * @param {'unlimited'|'generations'} gameType
 * @param {number} guessesUsed
 * @returns {number}
 */
export const getWinRewardCoins = (gameType, guessesUsed) => {
  const table = REWARD_TABLES[gameType] || UNLIMITED_WIN_COINS;
  const key = typeof guessesUsed === 'number' ? guessesUsed : null;
  return table.byGuessesUsed[key] ?? table.default;
};

/**
 * Get the loss coin reward (currently 0 for all modes).
 * @returns {number}
 */
export const getLossRewardCoins = () => LOSS_REWARD_COINS;
